import { getCounterpartyId } from '../../../services/authService';
import gql from 'graphql-tag';

export const getAllFundQuery = () => gql`
  {
    allBnyFunds(tenantId: "${getCounterpartyId()}") { 
    id 
    fundId 
    accountId
    shortCode
    shortName
    longName
    clientId 
    isActive
  }
}
`;

export const getAllClientsQuery = () => gql`
{
  allBnyClients(tenantId: "${getCounterpartyId()}") {
    tenantId
    clientId
    shortCode
    shortName
    longName
    isActive
  }
}
`;
